import React, { useCallback, useEffect, useRef, useState } from 'react';
import {
  Modal,
  Form,
  Input,
  Button,
  Select,
  Tabs,
  Col,
  Row,
  message,
  Checkbox,
} from 'antd';
import IntlMessages from '../../components/IntlMessage';
import { useIntl } from 'react-intl';
import cGroupsApi from '../../api/cgroups';
import useValidate from '../../hooks/useValidate';
import CountryData from '../../utils/countrydata';
import collaboratorApi from '../../api/collaborator';
import operatorsApi from '../../api/operators';
import { useMounted } from '../../hooks/useMounted';

const layout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 16 },
};
const { Option } = Select;

const collaborator_roles = [
  {
    id: 1,
    role: 'operator',
    attributes: ['operator_app'],
  },
  {
    id: 2,
    role: 'supervisor',
    attributes: [
      'bookings',
      'passenger_list',
      'finance',
      'report',
      'operator_app',
    ],
  },
  {
    id: 3,
    role: 'manager',
    attributes: ['bookings', 'passenger_list', 'finance', 'report', 'routes'],
  },
  {
    id: 4,
    role: 'admin',
    attributes: [
      'bookings',
      'passenger_list',
      'finance',
      'report',
      'operator_app',
      'routes',
    ],
  },
];
export default function CollaboratorForm(props) {
  const isMount = useRef(false);
  const { onClose, currentData, open } = props;
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const intl = useIntl();
  const [cGroups, setCGroups] = useState([]);
  const { isPhoneNumber } = useValidate();
  const place_pass = 'input password';

  let initialValues = {
    firstname:
      currentData && currentData.firstname ? currentData.firstname : '',
    lastname: currentData && currentData.lastname ? currentData.lastname : '',
    email: currentData && currentData.email ? currentData.email : null,
    accountant_email:
      currentData && currentData.accountant_email
        ? currentData.accountant_email
        : '',
    mobile: currentData && currentData.mobile ? currentData.mobile : '',
    phone_code:
      currentData && currentData.phone_code ? currentData.phone_code : '+221',
    cgroup_id: currentData && currentData.cgroup ? currentData.cgroup?.id : '',
    company_name:
      currentData && currentData.company_name ? currentData.company_name : '',
    company_shortname:
      currentData && currentData.company_shortname
        ? currentData.company_shortname
        : '',
    company_tax_id:
      currentData && currentData.company_tax_id
        ? currentData.company_tax_id
        : '',
    address: currentData && currentData.address ? currentData.address : '',
    office: currentData && currentData.office ? currentData.office : '',
    notes: currentData && currentData.notes ? currentData.notes : '',
    title: currentData && currentData.title ? currentData.title : '',
    userId: currentData && currentData.userId ? currentData.userId : null,
    operator_id:
      currentData && currentData.operator ? currentData.operator.id : '',
    contact_info:
      currentData && currentData.contact_info
        ? Array.isArray(currentData.contact_info)
          ? currentData.contact_info
          : JSON.parse(currentData.contact_info)
        : [],
    role:
      currentData && currentData.params
        ? JSON.parse(currentData.params)?.role
        : null,
    attribute:
      currentData && currentData.params
        ? JSON.parse(currentData.params)?.attribute
        : null,
  };

  // side effects
  useEffect(() => {
    isMount.current = true;
    (async function () {
      if (isMount) {
        let items = await cGroupsApi.getAll({
          page: 1,
          limit: 9999,
          keyword: '',
          order_by: 'id',
          order_dir: 'DESC',
        });
        // console.log('cGroups: ', items);
        const cGroupsData = items?.data;
        if (Array.isArray(cGroupsData)) {
          setCGroups(
            cGroupsData.map((cgroup) => ({
              label: `${cgroup?.title}${
                cgroup?.discount ? ` - ${cgroup?.discount}%` : ''
              }`,
              value: cgroup.id,
            }))
          );
        }
      }
    })();

    return () => {
      isMount.current = false;
    };
  }, []);

  const handleSubmit = () => {
    setLoading(true);

    form
      .validateFields()
      .then((values) => {
        let data = { ...values };
        data.contact_info = JSON.stringify(data.contact_info);
        if (data.role) {
          data.params = JSON.stringify({
            role: data.role,
            attribute: data.attribute,
          });
        }
        // console.log('values', data);
        if (!data?.password) {
          delete data.password;
        }
        if (data.role) {
          delete data.role;
        }
        if (data.attribute) {
          delete data.attribute;
        }
        console.log('data', data);
        if (currentData) {
          collaboratorApi
            .update(currentData.id, data)
            .then(() => {
              setLoading(false);
              handleCancel();
              props.onReload();
              message.success('Update collaborator successfully');
            })
            .catch((error) => {
              console.error(error);
              Modal.error({
                title: error.data.message,
                okText: intl.formatMessage({ id: 'global.close' }),
              });
              setLoading(false);
            });
        } else {
          collaboratorApi
            .create(data)
            .then(() => {
              setLoading(false);
              handleCancel();
              props.onReload();
              message.success('Create collaborator successfully');
            })
            .catch((error) => {
              console.error(error);
              Modal.error({
                title: error.data.message,
                okText: intl.formatMessage({ id: 'global.close' }),
              });
              setLoading(false);
            });
        }
      })
      .catch(() => setLoading(false));
  };

  const onFinishFailed = (errorInfo) => {
    console.error('Failed:', errorInfo);
  };

  const handleCancel = () => {
    //form.resetFields();
    onClose();
  };

  const [role, setRole] = useState(null);

  const onChangeRole = (role) => {
    setRole(role);
    form.setFieldValue(
      'attribute',
      collaborator_roles.find((i) => i.role === role).attributes
    );
  };
  const [operatorSelected, setOperatorSelected] = useState();
  const [operatorOption, setOperatorOption] = useState([]);
  const { isMounted } = useMounted();
  const onChangeOperator = (value) => setOperatorSelected(value);
  const fetch = useCallback(async () => {
    try {
      if (isMounted) {
        const filter = {
          page: 1,
          limit: 9999,
          order_by: 'id',
          order_dir: 'DESC',
          keyword: '',
        };
        const operator = await operatorsApi.getAll(filter);

        const list_operator = operator.data.map((item) => {
          return {
            label: item?.title,
            value: item?.id,
          };
        });
        setOperatorOption(list_operator);
      }
    } catch (err) {
      console.log(err);
    }
  }, [isMounted]);

  useEffect(() => {
    fetch();
  }, [fetch]);
  const tabItems = [
    {
      key: '1',
      label: <IntlMessages id="global.collaborators" />,
      children: (
        <>
          <Form.Item
            label="Operator"
            name="operator_id"
            rules={[
              {
                required: true,
                message: <IntlMessages id="global.requiredfield" />,
              },
            ]}>
            <Select onChange={onChangeOperator} options={operatorOption} />
          </Form.Item>
          <Form.Item
            label={<IntlMessages id="global.firstname" />}
            name="firstname"
            rules={[
              {
                required: true,
                message: <IntlMessages id="global.requiredfield" />,
              },
            ]}>
            <Input />
          </Form.Item>
          <Form.Item
            label={<IntlMessages id="global.lastname" />}
            name="lastname"
            rules={[
              {
                required: true,
                message: <IntlMessages id="global.requiredfield" />,
              },
            ]}>
            <Input />
          </Form.Item>
          <Form.Item
            label={<IntlMessages id="global.email" />}
            name="email"
            rules={[
              {
                type: 'email',
                message: <IntlMessages id="global.email_not_valid" />,
              },
              {
                required: false,
                message: <IntlMessages id="global.requiredfield" />,
              },
            ]}>
            <Input />
          </Form.Item>
          <Form.Item
            label={<IntlMessages id="global.phone" />}
            rules={[
              {
                required: true,
                message: <IntlMessages id="global.requiredfield" />,
              },
            ]}>
            <Input.Group>
              <Row gutter={16}>
                <Col span={8}>
                  <Form.Item
                    name="phone_code"
                    rules={[
                      {
                        required: true,
                        message: <IntlMessages id="global.requiredfield" />,
                      },
                    ]}>
                    <Select
                      style={{ width: '100%' }}
                      allowClear
                      showSearch
                      placeholder="Select type"
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }>
                      {CountryData.map((item, index) => {
                        let labelstr = '';
                        labelstr = `(+${item.code}) ${item.country}`;
                        return (
                          <Option key={index} value={`+${item.code}`}>
                            {labelstr}
                          </Option>
                        );
                      })}
                      ;
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={16}>
                  <Form.Item
                    name="mobile"
                    rules={[
                      {
                        required: true,
                        message: <IntlMessages id="global.requiredfield" />,
                      },
                    ]}>
                    <Input />
                  </Form.Item>
                </Col>
              </Row>
            </Input.Group>
          </Form.Item>

          <Form.Item
            label={<IntlMessages id="global.password" />}
            name="password">
            <Input.Password placeholder={place_pass} />
          </Form.Item>
        </>
      ),
    },
    {
      key: '2',
      label: <IntlMessages id="global.roles" />,
      children: (
        <>
          <Form.Item
            label={<IntlMessages id={`global.role`} />}
            labelCol={{ span: 4 }}
            name={'role'}>
            <Select
              style={{ width: 500 }}
              showSearch
              onChange={onChangeRole}
              filterOption={false}
              options={collaborator_roles.map((item, i) => {
                return {
                  label: <IntlMessages id={`select.${item.role}`} />,
                  value: item?.role,
                };
              })}
            />
          </Form.Item>
          {form.getFieldValue('role') && (
            <Form.Item
              label={<IntlMessages id="global.access" />}
              name="attribute"
              rules={[
                {
                  required: false,
                },
              ]}>
              <Checkbox.Group
                options={
                  collaborator_roles.find(
                    (i) => i.role === form.getFieldValue('role')
                  ).attributes || []
                }
                onChange={(value) => {
                  console.log('checked', value);
                }}
                style={{ flexDirection: 'column' }}
              />
            </Form.Item>
          )}
        </>
      ),
    },
  ];

  return (
    <Modal
      title={
        currentData ? (
          <IntlMessages id="global.edit" />
        ) : (
          <IntlMessages id="global.add" />
        )
      }
      open={open}
      destroyOnClose={true}
      onCancel={handleCancel}
      width="60%"
      onOk={handleSubmit}
      footer={[
        <Button key="back" type="default" onClick={handleCancel}>
          {<IntlMessages id="global.cancel" />}
        </Button>,
        <Button
          key="submit"
          type="primary"
          htmlType="submit"
          loading={loading}
          onClick={handleSubmit}>
          {<IntlMessages id="global.save" />}
        </Button>,
      ]}>
      <Form
        {...layout}
        form={form}
        initialValues={initialValues}
        labelAlign="left"
        onFinish={handleSubmit}
        onFinishFailed={onFinishFailed}>
        <Tabs defaultActiveKey="1" items={tabItems}></Tabs>
      </Form>
    </Modal>
  );
}
